module.exports = __webpack_public_path__ + "static/moon-6936afec20dee277266d56780f4abea9.jpg";